export const defineMixin = (options) => {
  return options
}
